import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import logo from "@/assets/logo.jpg";
import { COMPANY } from "@/data/site";

const links = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Ablauf", href: "#ablauf" },
  { label: "Rezensionen", href: "#rezensionen" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "glass-strong" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3">
          <img src={logo} alt="S&P Reinigungsservice" className="h-11 w-11 rounded-full object-cover ring-1 ring-white/20" />
          <span className="font-heading text-lg font-semibold tracking-tight text-white leading-none">
            S&amp;P <span className="text-cyan-glass">Reinigungsservice</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-white/60 hover:text-cyan-glass transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#kontakt"
          data-testid="header-cta"
          className="group relative inline-flex items-center gap-2 rounded-full bg-cyan-glass px-5 py-2.5 font-mono text-xs uppercase tracking-[0.15em] text-[#030712] font-medium transition-transform duration-200 active:scale-95 hover:shadow-[0_0_30px_rgba(0,229,255,0.5)]"
        >
          Angebot anfordern
        </a>
      </div>
    </motion.header>
  );
}
